import React, { useEffect, useRef, useState } from 'react';
import { Flex } from 'antd';
import classNames from 'classnames';

import useResizeLayout from '@Hooks/useResizeLayout';

import { BasicInformation } from './components/BasicInformation';
import { Details } from './components/Details';
import styles from './overview-tab.module.css';

interface OverviewTabProps {}

const OverviewTab: React.FC<OverviewTabProps> = () => {
  const { isMobile } = useResizeLayout();

  const ref = useRef<HTMLDivElement | null>(null);
  const [basicInfoHeight, setBasicInfoHeight] = useState(0);

  useEffect(() => {
    const height = (ref.current as HTMLDivElement).clientHeight;

    setBasicInfoHeight(height);
  }, []);

  return (
    <Flex
      className={classNames(styles.wrapper, isMobile ? 'mobile' : null)}
      ref={ref}
    >
      <BasicInformation height={basicInfoHeight} isMobile={isMobile} />
      <Details isMobile={isMobile} />
    </Flex>
  );
};

export default OverviewTab;
